import React from 'react';
import { getAvailableRegimens } from '../F22/registry';

const REGIMEN_LABELS = {
  '14d3': 'Pro PYME (14D3)',
};

/**
 * Paso 3 del wizard: preguntas + régimen tributario de la empresa para ESTE
 * año. El régimen se pregunta cada vez (no se lee de un campo fijo de la
 * empresa) porque puede cambiar de un año a otro.
 */
const RegimenStep = ({ anioTributario, selectedRegimen, onRegimenChange, onContinuar }) => {
  const regimenesDisponibles = getAvailableRegimens(anioTributario);

  return (
    <div className="wizard-regimen-container">
      <div className="regimen-selector">
        <label className="regimen-label">
          ¿Bajo qué régimen tributario declara esta empresa en AT {anioTributario}?
        </label>
        <div className="regimen-options">
          {regimenesDisponibles.map((regimen) => (
            <button
              key={regimen}
              className={`regimen-btn ${selectedRegimen === regimen ? 'active' : ''}`}
              onClick={() => onRegimenChange(regimen)}
            >
              {REGIMEN_LABELS[regimen] || regimen.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
      <div className="wizard-step-nav">
        <button className="wizard-btn-continuar" onClick={onContinuar} disabled={!selectedRegimen}>
          Continuar
        </button>
      </div>
    </div>
  );
};

export default RegimenStep;
